var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#747F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.208 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#818C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.208 8.75a1.042 1.042 0 1 1 0 2.083 1.042 1.042 0 0 1 0-2.083Z",
    fill: "#747F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.792a1.042 1.042 0 1 0-2.083 0 1.042 1.042 0 0 0 2.083 0Z",
    fill: "#818C96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.792a1.042 1.042 0 1 0-2.083 0 1.042 1.042 0 0 0 2.083 0Z",
    fill: "#747F88"
  })));
};

export default SvgMore;